/** PROTOTYPE Material Traceability inputs -- mill sources (shared editor) + MT add-on toggles. */
import React from 'react';
import { CRC } from './moduleInputsData';
import { Label, Toggle } from './protoAtoms';
import { Spread } from './spreadSplitData';
import { ModuleSource } from './spreadSourceData';
import { MtOptions, MT_ADDONS } from './spreadMaterialData';
import { SpreadSourceInputs } from './SpreadSourceInputs';

interface Props {
  spread: Spread;
  joints: number;
  setMills: (mills: ModuleSource[]) => void;
  setOptions: (options: MtOptions) => void;
}

export const SpreadMaterialInputs: React.FC<Props> = ({ spread, joints, setMills, setOptions }) => (
  <>
    <SpreadSourceInputs sources={spread.mtMills} setSources={setMills} noun="Mill" countLabel="Pipe count" joints={joints} />

    <div style={{ borderTop: `1px solid ${CRC.rowDivider}`, paddingTop: 18 }}>
      <div style={{ fontFamily: 'Funnel Sans', fontSize: 15, fontWeight: 600, color: CRC.blueprintBlue, marginBottom: 14 }}>Add-ons</div>
      <div style={{ display: 'flex', gap: 30, flexWrap: 'wrap' }}>
        {MT_ADDONS.map(({ key, label }) => (
          <div key={key}><Label>{label}</Label><div style={{ marginTop: 8 }}>
            <Toggle on={spread.mtOptions[key]} onClick={() => setOptions({ ...spread.mtOptions, [key]: !spread.mtOptions[key] })} label={spread.mtOptions[key] ? 'On' : 'Off'} />
          </div></div>
        ))}
      </div>
      <div style={{ marginTop: 12, fontSize: 11.5, color: CRC.heritageGrey }}>Flat one-time fees, pure margin (no internal cost).</div>
    </div>
  </>
);
